
import { Link } from "react-router-dom";
import { ArrowLeft, Edit, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";

interface LaunchHeaderProps {
  launchId?: number;
  onEditClick: () => void;
}

export const LaunchHeader = ({ launchId, onEditClick }: LaunchHeaderProps) => {
  return (
    <div className="flex items-center gap-4">
      <Button variant="ghost" size="icon" asChild>
        <Link to="/admin/launches">
          <ArrowLeft className="h-4 w-4" />
        </Link>
      </Button>
      <h1 className="text-2xl font-bold">Detalles del Lanzamiento</h1>
      <Button variant="outline" size="sm" className="ml-auto" onClick={onEditClick}>
        <Edit className="h-4 w-4 mr-2" />
        Editar
      </Button>
      <Button variant="outline" size="sm" asChild>
        <Link to={`/admin/submissions?launch_id=${launchId}`} className="flex items-center gap-2">
          <FileText className="h-4 w-4" />
          Ver todos los envíos
        </Link>
      </Button>
    </div>
  );
};
